import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

// Camera + photo library split button. The camera input uses capture="environment",
// which on Android/iOS opens the camera directly with no way to pick an existing photo,
// so the library gets its own input without capture.
export default function ImageUploadButtons({
  onUpload,
  onLibraryUpload = onUpload,
  hasError = false,
  disabled = false,
  loading = false,
  idPrefix,
  sx,
}) {
  const color = hasError ? "error" : "primary";
  const buttonDisabled = disabled || loading;

  return (
    <Box mt={1.5} display="flex" sx={sx}>
      <Button
        variant="outlined"
        color={color}
        fullWidth
        component="label"
        disabled={buttonDisabled}
        aria-label="Take photo"
        data-id="photo-camera-button"
        startIcon={loading && <CircularProgress size={20} />}
        sx={{
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderRight: "none",
        }}
      >
        <AddAPhotoIcon />
        <input
          type="file"
          accept="image/*"
          id={idPrefix && `${idPrefix}-button`}
          capture="environment"
          style={{ display: "none" }}
          disabled={buttonDisabled}
          onChange={onUpload}
        />
      </Button>
      <Button
        variant="outlined"
        color={color}
        component="label"
        disabled={buttonDisabled}
        aria-label="Upload from photo library"
        data-id="photo-library-button"
        sx={{
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }}
      >
        <PhotoLibraryIcon />
        <input
          type="file"
          accept="image/*"
          id={idPrefix && `${idPrefix}-library-button`}
          multiple
          style={{ display: "none" }}
          disabled={buttonDisabled}
          onChange={onLibraryUpload}
        />
      </Button>
    </Box>
  );
}
